import "./simulationResults.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";
import { IRRADIANCEDATA } from "../../../Features/irrediance";
import { kiloToMegaWatt } from "./projectOverview";

function tableRender2(dataArr) {
  let leftStatKw = dataArr;

  let percentages = [
    100,
    (100 * leftStatKw[1]) / leftStatKw[0],
    (100 * leftStatKw[2]) / leftStatKw[0],
    (100 * leftStatKw[3]) / leftStatKw[0],
  ];

  let strokeWidth = 15;
  let radii = [88, 72, 56, 40];
  let [cx, cy] = [98, 98];
  let circumferences = radii.map((val) => val * 2 * Math.PI);

  let strokeLength = circumferences.map(
    (cir, index) => (cir * percentages[index]) / 100
  );

  return (
    <div className="render-function">
      <div className="simulation-result">
        <div className="stat-graph">
          {/* Stat Graph */}
          <div className="graph">
            <svg height="210" width="210">
              <circle
                cx={cx}
                cy={cy}
                r={radii[0]}
                fill="none"
                stroke="rgba(0,0,0,0.05)"
                strokeWidth={strokeWidth}
                strokeLinecap="round"
              />
              <circle
                className=""
                style={{
                  transform: "rotate(7deg)",
                  transformOrigin: "center",
                }}
                cx={cx}
                cy={cy}
                r={radii[0]}
                fill="none"
                stroke="#27326A"
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeDasharray={`${strokeLength[0]},${circumferences[0]}`}
              />
              <circle
                cx={cx}
                cy={cy}
                r={radii[1]}
                fill="none"
                stroke="rgba(0,0,0,0.05)"
                strokeWidth={strokeWidth - 3}
                strokeLinecap="round"
              />
              <circle
                className=""
                style={{
                  transform: "rotate(4deg)",
                  transformOrigin: "center",
                }}
                cx={cx}
                cy={cy}
                r={radii[1]}
                fill="none"
                stroke="#60B8EE"
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeDasharray={`${strokeLength[1]},${circumferences[1]}`}
              />
              <circle
                cx={cx}
                cy={cy}
                r={radii[2]}
                fill="none"
                stroke="rgba(0,0,0,0.05)"
                strokeWidth={strokeWidth - 3}
                strokeLinecap="round"
              />
              <circle
                className=""
                style={{
                  transform: "rotate(-5deg)",
                  transformOrigin: "center",
                }}
                cx={cx}
                cy={cy}
                r={radii[2]}
                fill="none"
                stroke="#B7DCFF"
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeDasharray={`${strokeLength[2]},${circumferences[2]}`}
              />
              <circle
                cx={cx}
                cy={cy}
                r={radii[3]}
                fill="none"
                stroke="rgba(0,0,0,0.05)"
                strokeWidth={strokeWidth - 3}
                strokeLinecap="round"
              />
              <circle
                className=""
                style={{
                  transform: "rotate(-5deg)",
                  transformOrigin: "center",
                }}
                cx={cx}
                cy={cy}
                r={radii[3]}
                fill="none"
                stroke="#ff7f1e"
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeDasharray={`${strokeLength[3]},${circumferences[3]}`}
              />
              {/* <text className="svg-text-up" x="48" y="60">Yield</text>
                          <text className="svg-text-down" x="54" y="70">KW</text> */}
            </svg>
            <div className="graph-text">
              <span className="svg-text-up">Yield</span>
              <span className="svg-text-down">KWh</span>
            </div>
          </div>
          {/* Stat graph text */}
          <div className="graph-text-container">
            {/* one */}
            <div className="stat-info">
              <svg height="20" width="20">
                <circle
                  cx={10}
                  cy={10}
                  r={7.5}
                  fill="none"
                  stroke="#27326A"
                  strokeWidth={5}
                />
              </svg>
              <div className="ball-text">
                <span className="value">
                  {`${kiloToMegaWatt(Number(leftStatKw[0].toFixed(1)))}h`}
                </span>
                <br />
                {/* <div className='down'> */}
                <span className="normal">PV Yearly Yeild: </span>
                <span className="percent">{percentages[0].toFixed()} %</span>
                {/* </div> */}
              </div>
            </div>
            {/* Two */}
            <div className="stat-info">
              <svg height="20" width="20">
                <circle
                  cx={10}
                  cy={10}
                  r={7.5}
                  fill="none"
                  stroke="#60B8EE"
                  strokeWidth={5}
                />
              </svg>
              <div className="ball-text">
                <span className="value">
                  {`${kiloToMegaWatt(Number(leftStatKw[1].toFixed(1)))}h`}
                </span>
                <br />
                {/* <div className='down'> */}
                <span className="normal">Building Consumption: </span>
                <span className="percent">{percentages[1].toFixed()} %</span>
                {/* </div> */}
              </div>
            </div>
            {/* two */}
            <div className="stat-info">
              <svg height="20" width="20">
                <circle
                  cx={10}
                  cy={10}
                  r={7.5}
                  fill="none"
                  stroke="#B7DCFF"
                  strokeWidth={5}
                />
              </svg>
              {/* <div className='ball color2'></div> */}
              <div className="ball-text">
                <span className="value">
                  {`${kiloToMegaWatt(Number(leftStatKw[2].toFixed(1)))}h`}
                </span>
                <br />
                <span className="normal">Export Energy: </span>
                <span className="percent">{percentages[2].toFixed(1)} %</span>
              </div>
            </div>
            {/* three */}
            <div className="stat-info">
              <svg height="20" width="20">
                <circle
                  cx={10}
                  cy={10}
                  r={7.5}
                  fill="none"
                  stroke="#ff7f1e"
                  strokeWidth={5}
                />
              </svg>
              {/* <div className='ball color3'></div> */}
              <div className="ball-text">
                <span className="value">
                  {`${kiloToMegaWatt(Number(leftStatKw[3].toFixed(1)))}h`}
                </span>
                <br />
                <span className="normal">Import Energy:</span>
                <span className="percent"> {percentages[3].toFixed(1)} %</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const SimulationResult2 = (props) => {
  const { tableContent } = props;
  const pageDetail = tableContent.find(
    (item) => item.title === "Simulation Results"
  );
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const check = quantityInfo.allRoof;
  const roofDetail = roofData[roofIndex];

  const tcyValue = roofInfo?.value?.financialAnalysis?.tcy
    ? roofInfo.value.financialAnalysis.tcy
    : 0;
  const irradianceCity = roofInfo?.value?.nearestWeatherStation
    ? roofInfo.value.nearestWeatherStation
    : "Lahore";
  const irradiance =
    irradianceCity === "Select Weather Station"
      ? IRRADIANCEDATA["Lahore"]
      : IRRADIANCEDATA[irradianceCity];
  let totalCapacity = 0;
  let month = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];
  let data = [];
  let exportEnergy = 0;
  let importEnergy = 0;
  let pvGeneratedEnergy = 0;

  if (check) {
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i];
      if (element.structureType === "Single") {
        totalCapacity += Number(element.totalKilowatt);
      } else {
        const totalKilowatt = Number(
          element.multipleStructure
            .reduce((total, data) => total + data.totalKilowatt, 0)
            .toFixed(1)
        );
        totalCapacity += Number(totalKilowatt);
      }
    }
    for (let j = 0; j < 12; j++) {
      let value = 0;
      for (let i = 0; i < roofData.length; i++) {
        const element = roofData[i];
        value += element.actualGeneration[j];
      }
      pvGeneratedEnergy += value;
      value -= roofInfo.value.financialAnalysis[month[j]];
      data.push(value);
      if (value >= 0) {
        exportEnergy += value;
      } else {
        importEnergy += -value;
      }
    }
  } else {
    if (roofDetail.structureType === "Single") {
      totalCapacity = Number(roofDetail.totalKilowatt);
    } else {
      const totalKilowatt = Number(
        roofDetail.multipleStructure
          .reduce((total, data) => total + data.totalKilowatt, 0)
          .toFixed(1)
      );
      totalCapacity = Number(totalKilowatt);
    }
    for (let j = 0; j < 12; j++) {
      let value = roofDetail.actualGeneration[j];
      pvGeneratedEnergy += value;
      value -= roofInfo.value.financialAnalysis[month[j]];
      data.push(value);
      if (value >= 0) {
        exportEnergy += value;
      } else {
        importEnergy += -value;
      }
    }
  }

  totalCapacity = Number(totalCapacity.toFixed(1));

  let irradianceSum = Object.values(irradiance).reduce(
    (sum, value) => sum + value,
    0
  );
  const pvYeild = pvGeneratedEnergy / totalCapacity;
  const performancRatio = (1 - pvYeild / irradianceSum) * 100;

  let moduleConfiguration = [
    {
      title: "Total PV output",
      value: `${kiloToMegaWatt(totalCapacity)}p`,
    },
    {
      title: "PV yearly yeild",
      value: `${kiloToMegaWatt(Number(pvGeneratedEnergy.toFixed(1)))}h`,
    },

    {
      title: "Performance ratio",
      value: `${performancRatio.toFixed(2)} %`,
    },
    {
      title: "Building Consumption",
      value: `${kiloToMegaWatt(tcyValue)}h`,
    },

    {
      title: "Building power consumption",
      value: `${((tcyValue * 100) / pvGeneratedEnergy).toFixed(1)} %`,
    },
    {
      title: "Export Energy",
      value: `${kiloToMegaWatt(Number(exportEnergy.toFixed(1)))}h`,
    },
    {
      title: "Percentage of Export Energy",
      value: `${((exportEnergy * 100) / pvGeneratedEnergy).toFixed(1)} %`,
    },
    {
      title: "Import Energy",
      value: `${kiloToMegaWatt(Number(importEnergy.toFixed(1)))}h`,
    },
    {
      title: "Percentage of Import Energy",
      value: `${((importEnergy * 100) / pvGeneratedEnergy).toFixed(1)} %`,
    },
  ];

  let selfSimData = [pvGeneratedEnergy, tcyValue, exportEnergy, importEnergy];

  function tableRender(tableData) {
    return (
      <div className="render-function">
        <table className="render-table">
          <thead>
            <tr>
              <td>Property</td>
              <td>Value</td>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => {
              return (
                <tr key={index} className={index % 2 === 0 ? "one" : "two"}>
                  <td className="left">{item.title}</td>
                  <td className="right">{item.value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div id="simulation-results" className="simulation-results">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="sr-body">
        <p>Simulation Results</p>
        <div className="data-tables">
          {/* PV Panel */}
          {tableRender(moduleConfiguration)}
        </div>
        <p>Energy Comparison</p>
        {tableRender2(selfSimData)}
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default SimulationResult2;
